import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components/index";
import moment from "moment";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";

/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has

 */
export default class EngineerInfo extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Tickets._name);
		this.redirect = this.props.baseUrl;
		this.state.warning = false;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if (typeof this.props.getExpectedLabor == "function") {
			this.props.getExpectedLabor(this.state.tickets_financialss[0]?.expected_labor, this.state.tickets_financialss[0]?.pkey)
		}
	}

	loadSelfBefore = async (data) => {
		let {onData} = this.props;

		if (typeof onData === 'function') onData(data);

		return data;

	}

	closeTicket = async () => {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
		this.update = 'POST_TICKET_CLOSE';
		model.object.pkey = this.props.id;
		try {
			await model.submit(null, this.update);
		} catch (e) {
		}
		this.props.reloadPage();
	};

	markTime = async () => {
		if (this.state.incomplete_fields.length <= 0) {
			let start = this.state.opened;
			let model = new API.BuildClass(Types.Tickets._name, API.RequestType.UPDATE);
			if (start) {
				this.update = 'POST_TICKET_OFF_SITE';
			} else {
				this.update = 'POST_TICKET_ON_SITE';
			}
			model.object.pkey = this.props.id;
			try {
				await model.submit(null, this.update);
			} catch (e) {
			}
			this.props.reloadPage();
		} else {
			this.setState({warning: true})
		}
	}

	onSite(start, end, closed, warning) {
		// let closed = this.state.closed
		// let end = this.state.appointment_end
		// let start = this.state.appointment_start
		if (closed) {
			return (
				<h4> This ticket was closed on {moment(closed).format('MMMM Do YYYY, h:mm:ss a')}</h4>
			)
		} else if (start != null && end == null) {

			let endTime = moment(new Date())
			let startTime = moment(start).format("YYYY-MM-DD HH:mm")
			let duration = moment.duration(endTime.diff(startTime))
			let seconds = duration.asSeconds()
			seconds = Math.round(seconds)
			return (
				<div>
					<Parts.Timer
						hours={Math.floor(seconds / 3600)}
						minutes={Math.floor(seconds / 60) % 60}
						seconds={seconds % 60.}
						totalSeconds={seconds}

					/>
					{/*<span className={"danger"}>( ${this.calculateLabor(seconds)}) </span>*/}
				</div>


			)
		} else if (end) {
			return (
				<h4> Left Site at {moment(end).format('MMMM Do YYYY, h:mm:ss a')}</h4>

			)
		} else if (warning) {
			return (
				<span>
					<h5> Ticket {this.state.incomplete_ticket} has the following fields incomplete: </h5>
					{this.state.incomplete_fields.map((field, index) => {
						return (
							<p style={{marginBottom: '0px'}} key={index}> {field} </p>
						)
					})}
					<Button onClick={() => this.props.history.push(`/tickets/${this.state.incomplete_ticket}`)}>
						Go to Ticket
					</Button>
				</span>
			)
		} else {
			return (
				<h4> Not on Site </h4>
			)

		}

	}


	render() {
		/**
		 * @param {Tickets_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Tickets_Object} object
		 */
		let object = this.state
		let {loading} = this.state
		let site = this.onSite(object.opened, object.closed, object.closed, object.warning)
		let location = object.location_opened.split(",")
		const locationStyle = {
			marginTop: "1px",
			paddingTop: "1px,"
		}
		return (
			<Card>
				<CardContent>
					<fieldset>
						<div className={"row"}>
							<div className={"col-sm"}>
								<h3> {object.field_engineers.name_first + " " + object.field_engineers.name_last}</h3>
								<h4>
									Ticket Number:&nbsp;&nbsp;
									<span className={"text-danger"}>{object.pkey}</span>
								</h4>

								<FreshdeskTicketLink freshTicket={object.fresh_ticket} className="" />
								{site}
								{object.location_opened &&
								<div className={"row"}>
									<div className={"col-lg"}>
										<h4 style={locationStyle}>Latitude: <span className={"text-primary"}>{location[0]}</span></h4>
									</div>
									<div className={"col-lg"}>
										<h4 style={locationStyle}>Longitude: <span className={"text-primary"}>{location[1]}</span></h4>
									</div>
								</div>}
							</div>
							<div className={"col-lg"}>
								{!object.closed ?
									<div className={"row"} style={{paddingBottom: "8px"}}>
										<div className={"col-lg"}>
											<Button size="lg" color="secondary" block onClick={this.markTime}>
												<i className="fa fa-hourglass"/>&nbsp;&nbsp;
												{!object.opened ?
													<span>Mark Time On Site</span>
													: <span>Mark Time Off Site</span>
												}
											</Button>
										</div>
									</div> : null
								}
								<div className={"row"} style={{paddingBottom: "8px"}}>
									<div className={"col-lg"}>
										<a href={"https://squareup.com/dashboard/invoices/new"} target="_blank"
										>
											<Button size="lg" color="primary" block>
												<i className="fa fa-share-square"/>&nbsp;&nbsp;Send Invoice
											</Button>
										</a>

									</div>
								</div>
								{!object.opened ?
									<div className={"row"}>
										<div className={"col-lg"}>
											<Button onClick={this.closeTicket} size="lg" color="danger" block>
												<i className="fa fa-times"/>&nbsp;&nbsp;Close
											</Button>
										</div>
									</div>
									: null
								}
							</div>
						</div>
					</fieldset>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

